import React, { useContext, useEffect, useState } from 'react'
import ProcedureForm from './ProcedureForm'
import { useForm } from 'antd/es/form/Form'
import GlobalContext from '../GlobalContext'
import { get, putMultipart } from '../../Common/api'
import { useNavigate, useParams } from 'react-router'
import { Button, Flex, Spin } from 'antd'
import { t } from 'i18next'

export default function ProcedurePage () {
  const { id } = useParams()
  const navigate = useNavigate()
  const [procedure, setProcedure] = useState()
  const [actors, setActors] = useState()
  const [loading, setLoading] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getProcedure()
  }, [id])

  const getProcedure = async () => {
    setLoading(true)
    await get({
      url: `admin/procedures/${id}`,
      params: {},
      onSuccess: (res) => {
        setProcedure(res.procedure)
        setActors(res.actors.sort().map((actor) => ({ value: actor, label: actor })))
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onFinish = async (values) => {
    setLoading(true)
    await putMultipart({
      url: `admin/procedures/${id}`,
      params: values,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (res) => {
        setProcedure(res)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  return (
    <Spin spinning={loading} style={{ margin: '3em 0', padding: '1em', backgroundColor: 'white' }}>
      { procedure && <ProcedureForm form={form} onFinish={onFinish} actors={actors} procedure={procedure} /> }
      <Flex style={{ width: '200px' }} justify='space-around'>
        <Button type='primary' onClick={form.submit}>{t('Admin.btn.submit')}</Button>
        <Button type='primary' onClick={() => navigate('/admin/procedures')}>{t('Admin.btn.back')}</Button>
      </Flex>
    </Spin>
  )
}
